const type = 'SET_NEW_CARD_FORM_VALIDITY';

const setNewCardFormValidity = (data) => ({
  data,
  type,
});

export { type };
export default setNewCardFormValidity;
